import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { FirebaseAuthService } from 'src/app/Services/firebase-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})

export class SigninComponent {
  
  public loading: boolean = false;
  public submitted: boolean = false;
  selectedFile: any;
  public rememberCheck: boolean = false;
  public email: any;
  public password: any;
  public popMessage: any = '';
  public firebaseEnabled: boolean = false;

  loginData = new FormGroup({
    email: new FormControl('', Validators.compose([
      Validators.required, Validators.email
    ])),
    password: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') 
    ])),
  });
  
  get f() { return this.loginData.controls; }

  constructor(
    public router: Router,
    private service: GlobalService,
    private firebaseAuth: FirebaseAuthService
  ) { 
    if (localStorage.getItem('grw_Remember')) {
      var data = getLocalJSON('grw_Remember');
      this.email = data.email;
      this.password = data.password;
      this.rememberCheck = data.check;
    }
  }

  ngOnInit(): void {
    this.firebaseEnabled = this.firebaseAuth.isEnabled;
  }

  handleLoginSuccess(data: any) {
    localStorage.setItem('grw_login', <any> JSON.stringify(data || {}));
    localStorage.setItem('grw_logincurrency', data.userCurrency || '');
    localStorage.setItem('grw_currencySymbol', data.userCurrencySymbol || '');
    if (data.userCurrency && data.userCurrency !== '') {
      this.service.getConversionRate(data.userCurrency, 2);
    }
    this.service.setSubject(data);
    localStorage.setItem('grw_token', data.token);
    if (data.firstTimeLogin === false) {
      localStorage.setItem('grw_first', '1');  
      this.router.navigate(['/dashboard']);            
    } else {
      if (data.profile_complete === false) {
        this.router.navigate(['/edit-profile']);
      } else {
        this.router.navigate(['/dashboard']);
      } 
    }
    this.loginData.reset();
    this.submitted = false;  
    this.loading = false;
  }

  Onsubmit() {
    this.submitted = true;    
    let userdetail = this.loginData;
    if (userdetail.valid) {
      this.loading = true;
      var url = "/login";
      var detail = {
        "email": (userdetail.value.email)?.toLowerCase(),
        "password": userdetail.value.password
      };
      this.service.PostApis(detail, url).subscribe({
        next: (response: any) => {
          if (response.success == 1) {
            if (this.rememberCheck) {
              var rememberDetail = {
                'email': (userdetail.value.email)?.toLowerCase(),
                'password': userdetail.value.password,
                'check': this.rememberCheck
              };
              localStorage.setItem('grw_Remember', <any> JSON.stringify(rememberDetail));
            } else {
              localStorage.removeItem('grw_Remember');
            } 
            this.handleLoginSuccess(response.data);
          } else {
            if (response.message === 'Email verification is pending') {
              $('#pops').trigger('click');
              this.popMessage = response.message;
            }
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        },
        error: (error: any) => {
          this.loading = false;
        }
      });
    } else {
      window.scroll(0, 0);
    }
  }

  async loginWithGoogle() {
    try {
      this.loading = true;
      const { idToken, user } = await this.firebaseAuth.signInWithGoogle();
      this.processFirebaseLogin(idToken, user, 'Google');
    } catch (err: any) {
      this.loading = false;
      if (err?.code !== 'auth/popup-closed-by-user') {
        this.service.dangerAlert(err?.message || 'Google sign-in was cancelled or encountered an error.');
      }
    }
  }

  async loginWithApple() {
    try {
      this.loading = true;
      const { idToken, user } = await this.firebaseAuth.signInWithApple();
      this.processFirebaseLogin(idToken, user, 'Apple');
    } catch (err: any) {
      this.loading = false;
      if (err?.code !== 'auth/popup-closed-by-user') {
        this.service.dangerAlert(err?.message || 'Apple sign-in was cancelled or encountered an error.');
      }
    }
  }

  private processFirebaseLogin(idToken: string, user: any, provider: string = 'Google') {
    this.service.PostApis({ idToken }, '/firebase-login').subscribe({
      next: (response: any) => {
        if (response.success == 1) {
          if (response.data && response.data.isNewUser) {
            this.loading = false;
            this.service.dangerAlert('No account found for this ' + provider + ' account. Please sign up first.');
            return;
          }
          this.handleLoginSuccess(response.data);
        } else {
          this.loading = false;
          this.service.dangerAlert(response.message || ('No account found for this ' + provider + ' account. Please sign up first.'));
        }
      },
      error: (error: any) => {
        this.loading = false;
        this.service.dangerAlert(error?.message || 'An error occurred during social login.');
      }
    });
  }

  getCheckType(event: any) {
    this.rememberCheck = event.target.checked;
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa-regular fa-eye-slash");
      $(str).addClass("fa-regular fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("fa-regular fa-eye ");
      $(str).addClass("fa-regular fa-eye-slash");
    }
  }
}

